import { render, staticRenderFns } from "./PhysicalAddress.vue?vue&type=template&id=1eb0fdb5&"
import script from "./PhysicalAddress.vue?vue&type=script&lang=js&"
export * from "./PhysicalAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports